import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "antd/dist/antd.min.css";
import { DataGrid } from "@material-ui/data-grid";
import { makeStyles } from "@material-ui/core/styles";
import AuthContext from "../../../../components/shared/Context";

const useStyles = makeStyles({
  root: {
    "& .expired": {
      backgroundColor: "#ffcdd2",
      color: "#c62828",
    },
  },
});

const ExpiredProductsList = () => {
  const classes = useStyles();
  let navigate = useNavigate();
  const { loggedInUserDetails } = useContext(AuthContext);
  const [products, setProducts] = useState([]);

  const columns = [
    { field: "item_code", headerName: "Item Code", width: 150 },
    { field: "product_name", headerName: "Product Name", width: 300 },
    { field: "category", headerName: "Category", width: 150 },
    {
      field: "product_expiry",
      headerName: "Expiry Date",
      width: 150,
      valueFormatter: (params) => {
        return new Date(params.value).toLocaleDateString();
      },
    },
    { field: "quantity", headerName: "Quantity", width: 150 },
    { field: "tc_name", headerName: "Treatment Center", width: 200 },
    { field: "state", headerName: "State", width: 130 },
    { field: "company_name", headerName: "Company", width: 150 },
    {
      field: "daysExpired",
      headerName: "Days Expired",
      width: 150,
      valueGetter: (params) => {
        const days = calculateDaysLeft(params.row.product_expiry);
        return Math.abs(days);
      },
    },
  ];

  const calculateDaysLeft = (date) => {
    const givenDate = new Date(date);
    const timeDiff = givenDate.getTime() - new Date().getTime();
    return Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  };

  useEffect(() => {
    const getProductsDataFromServer = () => {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      };

      const bodyParameters = {
        key: "value",
      };

      let urlLink = `${process.env.REACT_APP_API_URL}/tcpwstock/`;

      axios
        .get(urlLink, config)
        .then((res) => {
          const oldData = res.data.product_stock;
          // console.log(oldData);
          const ExpiredProduct = oldData.filter((product) => {
            return calculateDaysLeft(product?.product_stock?.expiry_date) <= 0;
          });
          const updatedData = ExpiredProduct.map((data) => {
            //   console.log(data.purchase_inventory.product_id.products);
            return {
              ...data,
              id: data?._id,
              stock_type: data?.product_stock?.stock_type, //newly added
              product_name:
                data?.product_stock?.product_id?.products?.product_name,
              category:
                data?.product_stock?.product_id?.products?.category_id
                  ?.category,
              item_code: data?.product_stock?.item_code,
              measuring_unit:
                data?.product_stock?.product_id?.products?.measuring_unit,
              company_name:
                data?.product_stock?.product_id?.products?.company_name,
              product_expiry: data?.product_stock?.expiry_date,
              tc_name: data?.product_stock?.tc_id?.tcenters?.name_tc,
              state: data?.product_stock?.tc_id?.tcenters?.state,
              quantity:
                data?.product_stock?.quantity +
                " " +
                data?.product_stock?.product_id?.products?.storage_unit,
              updatedAt: data?.updatedAt,
            };
          });
          // console.log(updatedData);
          setProducts(updatedData);
        })
        .catch((err) => console.log("error", err));
    };
    getProductsDataFromServer();
  }, []);

  return (
    <div style={{ height: 600, width: "100%" }} className="mt-3">
      {/* <h2>Expired Products List</h2> */}
      <div style={{ display: "flex", height: "100%" }}>
        <div style={{ flexGrow: 1 }}>
          <DataGrid
            className={classes.root}
            rows={products || []}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10, 25, 50]}
            disableSelectionOnClick
            getRowClassName={(params) => "expired"}
            autoHeight
          />
        </div>
      </div>
    </div>
  );
};

export default ExpiredProductsList;
